import styled from "styled-components";

export const Container = styled.main`
  text-align: center;
  line-height: 2;
  strong{
    margin-bottom: 24px;
    display: inline-block;
    strong{
      font-size: inherit;
    }
  }



  @media screen and (min-width: 501px) {
  }

  @media (max-width: 500px) {
  }
`